import React from 'react';

const TrebleClef = props => (

   <svg
      className="clef treble"
      width="35"
      height="65"
      viewBox="0 0 683.61717 1523.3183"
   >
       <title>Treble Clef</title>
   <g
   ><g
    
      id="g247"
      transform="matrix(0.09170451,0,0,0.09170451,-40.594256,171.31066)"><g
         transform="matrix(3.817349,0,0,3.808092,-3380.452,-23251.63)"><path
                  d="m 1995.7906,7980.4431 c -61,17 -116,55 -167,113 -51,59 -76,124 -76,194 0,44 15,94 44,147 29,54 73,93 130,118 19,4 28,14 28,28 0,5 -7,10 -24,14 -91,-23 -166,-72 -224,-145 -58,-74 -88,-158 -90,-254 3,-103 34,-199 93,-287 60,-89 137,-152 231,-189 l -69,-355 c -154,128 -279,261 -376,401 -97,139 -147,290 -151,453 2,73 17,144 45,212 28,69 70,131 126,188 113,113 260,172 439,178 61,-4 126,-15 196,-33 z m 72,-10 156,769 c 154,-62 231,-197 231,-403 -9,-69 -29,-131 -63,-186 -33,-56 -77,-100 -133,-132 -56,-32 -119,-48 -191,-48 z m -205,-1040 c 33,-20 71,-55 112,-104 41,-48 81,-105 119,-169 39,-65 70,-131 93,-198 23,-66 34,-129 34,-187 0,-25 -2,-50 -7,-72 -4,-36 -15,-64 -34,-83 -19,-18 -43,-28 -73,-28 -60,0 -114,37 -162,111 -37,64 -68,140 -90,226 -23,87 -36,173 -38,260 5,99 21,180 46,244 z m -63,58 c -45,-162 -70,-327 -75,-495 1,-108 12,-209 33,-303 20,-94 49,-175 87,-245 37,-70 80,-123 128,-159 43,-32 74,-49 91,-49 13,0 24,5 34,14 10,9 23,24 39,44 119,169 179,373 179,611 0,113 -15,223 -45,333 -29,109 -72,213 -129,310 -58,98 -126,183 -205,256 l 81,394 c 44,-5 74,-9 91,-9 76,0 144,16 207,48 63,32 117,75 161,130 44,54 78,116 102,186 23,70 36,143 36,219 0,118 -31,226 -93,323 -62,97 -155,168 -280,214 8,49 22,120 43,211 20,92 35,165 45,219 10,54 14,106 14,157 0,79 -19,149 -57,211 -39,62 -91,110 -157,144 -65,34 -137,51 -215,51 -110,0 -206,-31 -288,-92 -82,-62 -126,-145 -130,-251 3,-47 14,-91 34,-133 20,-42 47,-76 82,-102 34,-27 75,-41 122,-44 39,0 76,11 111,32 34,22 62,51 83,88 20,37 31,78 31,122 0,59 -20,109 -60,150 -40,41 -91,62 -152,62 h -23 c 39,60 103,91 192,91 45,0 91,-10 137,-28 47,-19 86,-44 119,-76 33,-32 55,-66 64,-102 17,-41 25,-98 25,-169 0,-48 -5,-96 -14,-144 -9,-47 -23,-110 -42,-188 -19,-77 -33,-137 -41,-178 -60,15 -122,23 -187,23 -109,0 -212,-22 -309,-67 -97,-45 -182,-107 -256,-187 -73,-80 -130,-170 -171,-272 -40,-101 -61,-207 -62,-317 4,-102 23,-200 59,-292 36,-93 82,-181 139,-263 57,-82 116,-157 177,-224 62,-66 143,-151 245,-254 z"
                  id="path9-06"
               /><path
                  className="fil0 str0"
                  d="M 977.79056,6475.0585 H 2986.1709"
                  id="path17-4"
               /><path
                  className="fil0 str0"
                  d="M 977.79046,7077.5734 H 2986.1709"
                  id="path17-5"
               /><path
                  className="fil0 str0"
                  d="M 977.79054,7679.0688 H 2986.171"
                  id="path17-04"
               /><path
                  className="fil0 str0"
                  d="M 977.79046,8281.5837 H 2986.1709"
                  id="path17-8"
               /><path
                  className="fil0 str0"
                  d="M 977.79046,8883.0791 H 2986.1709"
                  id="path17-54"
               /></g></g></g>
   </svg >
);

export default TrebleClef;